import { render } from "./PartyDetails.vue?vue&type=template&id=013fa6a8&scoped=true"
import script from "./PartyDetails.vue?vue&type=script&lang=js"
export * from "./PartyDetails.vue?vue&type=script&lang=js"

import "./PartyDetails.vue?vue&type=style&index=0&id=013fa6a8&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013fa6a8"]])

export default __exports__